import script from "./SelectElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectElement.vue?vue&type=script&lang=ts&setup=true"

import "./SelectElement.vue?vue&type=style&index=0&id=0a01fe4e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a01fe4e"]])

export default __exports__